import type React from "react";
import { useContext } from "react";
import { SchemeContext } from "../../reducers/scheme";
import {
  type Option,
  SelectComboField,
  type SelectComboFieldProps,
} from "../Forms/SelectCombo/SelectCombo";

type SchemeSelectFormComponentProps = Omit<SelectComboFieldProps, "options"> & {
  allowAll?: boolean;
};
export default function SchemeSelectFormComponent(
  props: SchemeSelectFormComponentProps,
): React.ReactElement {
  const { allowAll = false } = props;
  const { state } = useContext(SchemeContext);
  const { loading, schemes = [] } = state;
  const ready = !state.loading && !state.error;
  const haveSchemes = schemes && schemes.length > 0;
  const options: Option[] = [
    ...(allowAll ? [{ label: "All", value: "undefined" }] : []),
    ...schemes.map((scheme) => {
      return {
        label: `${scheme.scheme_name} (${scheme.scheme_id})`,
        value: scheme.scheme_id,
      };
    }),
  ];

  const altText: string = ready
    ? haveSchemes
      ? "All"
      : "No Groups"
    : loading
      ? "Loading Schemes"
      : state.error?.message || "Error Loading Groups";

  return (
    <SelectComboField
      {...props}
      disabled={loading || props.disabled}
      options={[...options]}
      placeholder={altText}
    />
  );
}
